import { isEmpty } from "Util/isEmpty"
import { searchStringFrom } from "Util/searchStringFrom"

import { Nullable } from "./Nullable"

export type Email = {
    email: string
    searchStrings: {
        email: string
    }
}

export function emailFrom(email: ''): null
export function emailFrom(email: string): Email
export function emailFrom(email: Nullable<string>): null
export function emailFrom(email: Nullable<string>): Nullable<Email> {
    if (isEmpty(email)) {
        return null
    }
    return {
        email,
        searchStrings: {
            email: searchStringFrom(email),
        },
    }
}

export function noEmailText(name?: string) {
    return isEmpty(name) ? 'Ingen E-post' : name
}
